import "./EditFunctionalityTypeInformation.html";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditFunctionalityTypeInformationComponentController from "./EditFunctionalityTypeInformationComponentController";

export class EditFunctionalityTypeInformationComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditFunctionalityTypeInformationComponentController;
        this.templateUrl =
            "/App/Components/EquipmentFunctionalityType/" +
            "BasicInformation/EditFunctionalityTypeInformation/EditFunctionalityTypeInformation.html";
    }
}

module("mmManagePortal").component(
    "irEditFunctionalityTypeInformation",
    new EditFunctionalityTypeInformationComponent(),
);
